import { Directive, Input, HostListener, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

@Directive({
    selector: '[appDebounceClick]'
})
export class DebounceDirective implements OnInit, OnDestroy {
    @Input() debounceTime = 500;
    @Output() appDebounceClick = new EventEmitter();
    private clicks = new Subject();
    private subscription: Subscription;

    constructor() { }

    ngOnInit() {
        this.subscription = this.clicks.pipe(
            debounceTime(this.debounceTime)
        ).subscribe(e => this.appDebounceClick.emit(e));
    }

    @HostListener('click', ['$event'])
    clickEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        this.clicks.next(event);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}
